export const satosRed = {
  50: 'hsl(5, 80%, 95%)',
  100: 'hsl(5, 78%, 84%)',
  200: 'hsl(5, 74%, 72%)',
  300: 'hsl(5, 76%, 58%)',
  400: 'hsl(5, 90%, 48%)',
  500: 'hsl(5, 98%, 42%)',
  600: 'hsl(5, 98%, 37%)',
  700: 'hsl(5, 98%, 32%)',
  800: 'hsl(5, 98%, 27%)',
  900: 'hsl(5, 98%, 21%)',
} as const;

export const FontFamilies = {
  sourceSans: ['"Source Sans 3"', 'sans-serif', '-apple-system'].join(','),
} as const;

export enum FontSizes {
  f12 = '12px',
  f14 = '14px',
  f16 = '16px',
  f18 = '18px',
  f20 = '20px',
  f24 = '24px',
  f30 = '30px',
  f36 = '36px',
  f48 = '48px',
  f60 = '60px',
  f72 = '72px',
}

export enum Spacings {
  s4 = '4px',
  s8 = '8px',
  s12 = '12px',
  s16 = '16px',
  s20 = '20px',
  s24 = '24px',
  s32 = '32px',
  s48 = '48px',
  s64 = '64px',
  s80 = '80px',
  s96 = '96px',
  s128 = '128px',
  s192 = '192px',
  s256 = '256px',
  s384 = '384px',
  s512 = '512px',
  s640 = '640px',
  s768 = '768px',
}

export enum BorderRadii {
  br8 = '8px',
  br12 = '12px',
}
